import { FieldOrigin } from 'config'

import { BorrowerSeperator } from './config'

export const borrowerMenuKey = (borrowerSeparator: BorrowerSeperator, menuKey: string) => {
  const index = Object.values(BorrowerSeperator).indexOf(borrowerSeparator as any)
  return `${menuKey}${index == 0 ? '' : index + 1}`
}

export const borrowerSepFromMenuKey = (menuKey: string) => {
  const lastDigit = Number(menuKey.substring(menuKey.length - 1))
  if (Number.isNaN(lastDigit)) return BorrowerSeperator.BORROWER

  return Object.values(BorrowerSeperator)[lastDigit - 1]
}

export const getBorrowerOriginalMenuKey = (menuKey: string) => {
  // const match = menuKey.match(/^[a-zA-Z]+/)
  // if (match) return match[0]
  // return menuKey
  return menuKey.substring(0, menuKey.length - 1)
}

export const menuKeyToFieldOrigin = (menuKey: string): FieldOrigin | string => {
  const map: Record<string, FieldOrigin> = {
    borrower: FieldOrigin.BorrowerInformation,
    property: FieldOrigin.PropertyInformation,
    employment: FieldOrigin.EmploymentAndIncome,
    asset: FieldOrigin.AssetLiability,
    track: FieldOrigin.TrackRecord,
    hmda: FieldOrigin.DeclarationsHMDA,
    additionalMember: FieldOrigin.AdditionalMember,
  }
  return map[menuKey] ?? menuKey
}
